import { Table } from 'element-ui'
export default {
  extends: Table,
  name: 'el-table',
  mounted() {
    //this.doLayout();
    this.$nextTick(() => {
        this.doLayout();
    });
  },
  methods: {
    doLayout (...args) {
      Table.methods.doLayout.call(this, ...args)
      this.fixLayout() // Looks like we can do it once?
    },

    fixLayout () {
      // Safari header/content misalign fix (possible other browsers?)
      this.columns.forEach(c => {
        // element-ui/packages/table/src/layout-observer.js:49
        const width = c.realWidth || c.width
        const th = this.$el.querySelector(`table.el-table__header th.${c.id}`)
        if (th) {
          if (th.offsetWidth !== width) {
            th.style.cssText  = `min-width: ${width}px; max-width: ${width}px;`
          }
          let td
          for (td of this.$el.querySelectorAll(`table.el-table__body td.${c.id}`)) {
            if (td.offsetWidth === width) break
            td.style.cssText  = `min-width: ${width}px; max-width: ${width}px;`
          }
        }
      })
    }
  }
}